import * as BaseApi from './utilities/baseApi';

// This module provides a wrapper around the Fetch API to ensure our
// API calls have required properties and behaviour, such as sending
// required cookies or headers. Also includes convenience methods
// for dealing with JSON.

let { callApi, callApiReturnJson, callApiSendJson } = BaseApi;

/**
In general, the wrapper follows the same usage as Fetch.
See: https://github.github.io/fetch/

However, using this wrapper:

* API_BASE_PATH is prepended to endpoint if needed.
* cookies are handled
* Correlation ID header is appended and cached as needed.
* Non HTTP 2xx responses return an error with response and statusText.

Available Api methods:

(1) Api.call -- Basic Fetch wrapper.
    Returns full response.

Example Usage:
Api.call(endpoint, options).then(response => {
    // handle HTTP response
});

(2) Api.getJson -- Convenience method for GET requests.
    Returns parsed JSON.

Example Usage
Api.getJson(endpoint).then(json => {
    // handle json
});

(3) Api.postJson -- Convenience method for POST requests.
    Sends body as JSON. Returns full response.

Example Usage:
Api.postJson(endpoint, body);

(4) Api.putJson -- Convenience method for PUT requests.
    Sends body as JSON. Returns full response.

Example Usage:
Api.putJson(endpoint, body);

(5) Api.postJsonReturnJson -- Convenience method for POST requests.
    Sends body as JSON. Returns parsed JSON body.

Example Usage:
Api.postJsonReturnJson(endpoint, body).then(json => {
  // handle json
});

(6) Api.putJsonReturnJson -- Convenience method for PUT requests.
    Sends body as JSON. Returns parsed JSON body.

Example Usage:
Api.putJsonReturnJson(endpoint, body).then(json => {
  // handle json
});
 */
const Api = {
  // Send request to API and return response object.
  call: (endpoint, properties = {}) => callApi(endpoint, properties),
  // Send GET request and return parsed JSON body.
  getJson: (endpoint, properties = {}) => callApiReturnJson(endpoint, properties),
  // Send POST request with body as JSON. Return response object.
  postJson: (endpoint, body = {}, properties = {}) =>
    callApiSendJson(endpoint, 'POST', body, properties),
  // Send PUT request with body as JSON. Return response object.
  putJson: (endpoint, body = {}, properties = {}) =>
    callApiSendJson(endpoint, 'PUT', body, properties),
  // Send POST request with body as JSON. Return parsed JSON.
  postJsonReturnJson: (endpoint, body = {}, properties = {}) =>
    callApiSendJson(endpoint, 'POST', body, properties).then(response => response.json()),
  // Send PUT request with body as JSON. Return parsed JSON.
  putJsonReturnJson: (endpoint, body = {}, properties = {}) =>
    callApiSendJson(endpoint, 'PUT', body, properties).then(response => response.json()),
};

// Inject baseAPi to facilitate testing.
export const inject = (mockedBaseApi = BaseApi) => {
  ({ callApi, callApiReturnJson, callApiSendJson } = mockedBaseApi);
};

export default Api;



// WEBPACK FOOTER //
// ./src/Shared/Services/api.js